export default function TrustSection() {
  const steps = [
    {
      icon: 'ri-search-line',
      title: 'Browse Spreadsheet',
      desc: 'Explore our organized pandabuy spreadsheet with 14 carefully curated categories.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Compare Products',
      desc: 'Compare quality ratings, prices, and shipping estimates side by side instantly.',
    },
    {
      icon: 'ri-links-line',
      title: 'Copy Item Links',
      desc: 'Grab the product links you want and prepare them for your shopping agent.',
    },
    {
      icon: 'ri-shopping-bag-3-line',
      title: 'Purchase via Agent',
      desc: 'Use your preferred shopping agent to complete the purchase seamlessly.',
    },
    {
      icon: 'ri-camera-lens-line',
      title: 'Track QC Updates',
      desc: 'Monitor quality control photos and shipping status in your agent dashboard.',
    },
  ];

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium tracking-wider uppercase mb-5">
            <i className="ri-star-smile-line text-sm"></i>
            Trusted by Shoppers Worldwide
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            How It Works
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {steps.map((step, idx) => (
            <div key={idx} className="relative group">
              <div className="bg-background-100 rounded-2xl p-6 h-full transition-all duration-300 hover:-translate-y-1">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
                  <i className={`${step.icon} text-accent-600 text-xl`}></i>
                </div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-bold text-accent-500">0{idx + 1}</span>
                  <span className="w-8 h-px bg-accent-300"></span>
                </div>
                <h4 className="font-semibold text-foreground-950 text-sm mb-2">
                  {step.title}
                </h4>
                <p className="text-foreground-500 text-xs leading-relaxed">
                  {step.desc}
                </p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-accent-200"></div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-14 bg-secondary-50 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="flex-shrink-0 w-16 h-16 rounded-full bg-secondary-200 flex items-center justify-center">
            <i className="ri-information-line text-secondary-700 text-2xl"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h4 className="font-semibold text-foreground-950 mb-1">Disclaimer</h4>
            <p className="text-foreground-500 text-sm leading-relaxed">
              This website provides informational spreadsheet data only. We do not sell
              products directly and are not responsible for third-party transactions,
              shipping delays, or product quality variations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}